import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
//MUI
import makeStyles from '@material-ui/core/styles/makeStyles';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import {colors} from '@material-ui/core';
//DS
import ListaMultiNivel from '../ListaMultiNivel';
import {hidden} from '../../../common/helpers';
//ESTILOS
const useStyles = makeStyles((theme) => ({
   nested: {
      paddingLeft: theme.spacing(3)
   },
   item: {
      display: 'flex',
      paddingTop: 0,
      paddingBottom: 0,
      width: '120%'
   },
   button: {
      color: colors.blueGrey[800],
      padding: '10px 16px',
      justifyContent: 'flex-start',
      textTransform: 'none',
      letterSpacing: 0,
      width: '100%',
      fontWeight: theme.typography.fontWeightMedium
   },
   icon: {
      color: theme.palette.icon,
      width: 24,
      height: 24,
      display: 'flex',
      alignItems: 'center',
      marginRight: theme.spacing(1),
      minWidth: '40px'
   }
}));

function Item({
   arbol,
   mapaArbol,
   itemComponent,
   noAnidado,
   contraerTodos,
   onItemClick,
   hide,
   ...rest
}) {
   const classes = useStyles();
   function handleClick() {
      if (onItemClick) {
         onItemClick(arbol);
      }
   }
   const {
      [mapaArbol.titulo]: titulo,
      [mapaArbol.icono]: icono,
      [mapaArbol.nodos]: nodos,
      ...nodoExtraProps
   } = arbol;
   if (hidden(nodoExtraProps)) {
      return null;
   }
   if (hide(arbol)) {
      return null;
   }
   if (nodos && nodos.length > 0) {
      return (
         <ListItem className={clsx(classes.item, {[classes.nested]: !noAnidado})}>
            <ListaMultiNivel
               arbol={arbol}
               mapaArbol={mapaArbol}
               itemComponent={itemComponent}
               contraerTodos={contraerTodos}
               onItemClick={onItemClick}
            />
         </ListItem>
      );
   } else {
      return (
         <ListItem className={clsx(classes.item, {[classes.nested]: !noAnidado})} disableGutters>
            <Button
               className={clsx(classes.button)}
               component={itemComponent}
               itemprops={nodoExtraProps}
               onClick={handleClick}
            >
               {icono && <div className={classes.icon}>{icono}</div>}
               {titulo}
            </Button>
         </ListItem>
      );
   }
}

Item.propTypes = {
   /**
    * Arbol con nodos anidados uno dentro de otro.
    */
   arbol: PropTypes.object.isRequired,
   /**
    * Equivalencia de las propiedades usadas por el componente y las proporcionados por los nodos de los `arboles`, donde:
    *
    * - `titulo`: Propiedad de los nodos de los `arboles` que contine el texto del item de la lista.
    * - `icono`: Propiedad de los nodos de los `arboles` que contine el icono del item de la lista.
    * - `nodos`: Propiedad de los nodos de los `arboles` que contine los nodos o hijos del nodo.
    *
    */
   mapaArbol: PropTypes.shape({
      titulo: PropTypes.string.isRequired,
      icono: PropTypes.string.isRequired,
      nodos: PropTypes.string.isRequired
   }),
   /**
    * Elemento que renderizara los item hojas de la lista, este componente recibira las propiedades adicionales nod definidad en `mapaArbol`.
    */
   itemComponent: PropTypes.elementType,
   /**
    * Si es __true__ se aplicaran estilo de un elemetno anidado.
    */
   noAnidado: PropTypes.bool,
   /**
    * Si es __true__, todos los item que pueden contraerse se contraeran.
    */
   contraerTodos: PropTypes.bool,
   /** Función que determina si un node es visible, con la siguiente firma:
    *
    * - `arbol`: objeto, con la misma forma a los del array de la propiedad __arbol__.
    * - `retorno`: boolean, si es __true_ el nodo no sera renderizado.
    * */
   hide: PropTypes.func
};
Item.defaultProps = {
   mapaArbol: {
      titulo: 'titulo',
      icono: 'icono',
      nodos: 'nodos'
   },
   noAnidado: false
};

export default Item;
